import React, { createContext, useCallback, useContext, useMemo, useState, ReactNode } from 'react';

export interface TeacherNavTool {
  id: string;
  emoji: string;
  label: string;
  onClick: () => void;
}

interface TeacherToolsContextValue {
  tools: TeacherNavTool[];
  setTools: (tools: TeacherNavTool[]) => void;
  clearTools: () => void;
}

const TeacherToolsContext = createContext<TeacherToolsContextValue | undefined>(undefined);

export const TeacherToolsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [tools, setToolsState] = useState<TeacherNavTool[]>([]);

  const setTools = useCallback((next: TeacherNavTool[]) => {
    setToolsState(next);
  }, []);

  const clearTools = useCallback(() => {
    setToolsState([]);
  }, []);

  const value = useMemo(
    () => ({ tools, setTools, clearTools }),
    [tools, setTools, clearTools]
  );

  return (
    <TeacherToolsContext.Provider value={value}>
      {children}
    </TeacherToolsContext.Provider>
  );
};

export function useTeacherTools(): TeacherToolsContextValue {
  const ctx = useContext(TeacherToolsContext);
  if (!ctx) {
    throw new Error('useTeacherTools must be used within TeacherToolsProvider');
  }
  return ctx;
}
